// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { addToChainAfter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { RmaLineDto, RmaModel } from "@insite/client-framework/Types/ApiModels";

export const XngPopulateApiParameter: typeof PopulateApiParameter  = props => {
    const state = props.getState();
    const orderLines = state.pages.requestRma.orderLines;
    if (orderLines.length === 0) {
        return false;
    }

    props.apiParameter = {
        rmaModel: {
            orderNumber: props.parameter.orderNumber,
            notes: state.pages.requestRma.returnNotes || "",
            properties: (props.parameter as any)?.properties,
            rmaLines: orderLines
                .map(orderLine => {
                    return {
                        line: orderLine.lineNumber,
                        rmaQtyRequested: orderLine.rmaQtyRequested,
                        rmaReasonCode: orderLine.returnReason,
                    } as RmaLineDto;
                })
                .filter(x => x.rmaQtyRequested > 0),
        } as RmaModel,
    };
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
